export default "__VITE_ASSET__CcXo1jQP__"